import React from 'react';
import PropTypes from 'prop-types';
import Simplified from './views/Simplified';
import SearchPoster from './views/SearchPoster';
import WatchlistPoster from './views/WatchlistPoster';
import BrowsePoster from './views/BrowsePoster';

const SIMPLIFIED = 'SIMPLIFIED';
const SEARCH_POSTER = 'SEARCH_POSTER';
const WATCHLIST_POSTER = 'WATCHLIST_POSTER';
const BROWSE_POSTER = 'BROWSE_POSTER';

const Poster = ({ type, ...rest }) => {
  const components = {
    // latestEpisode: LatestEpisode,
    // poster: Poster,
    [SIMPLIFIED]: Simplified,
    [SEARCH_POSTER]: SearchPoster,
    [WATCHLIST_POSTER]: WatchlistPoster,
    [BROWSE_POSTER]: BrowsePoster,
  };
  const Component = components[type];
  if (!type) return null;
  return <Component {...rest} />;
};

Poster.propTypes = { type: PropTypes.string.isRequired };

// eslint-disable-next-line import/no-unused-modules
export { Poster, SIMPLIFIED, SEARCH_POSTER, WATCHLIST_POSTER, BROWSE_POSTER };
